import { Link, useLocation } from "react-router-dom";
import { Users } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { ActivityCenter } from "@/components/layout/ActivityCenter";
import { UserMenu } from "./UserMenu";
import { useConnectionNotifications } from "@/hooks/useConnectionNotifications";
import { cn } from "@/lib/utils";

interface UtilityNavProps {
  showConnectionsLink?: boolean;
  className?: string;
}

export function UtilityNav({ showConnectionsLink = true, className }: UtilityNavProps) {
  const location = useLocation();
  const { pendingCount } = useConnectionNotifications();

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className={cn("flex items-center gap-2 sm:gap-3", className)}>
      {showConnectionsLink && (
        <Link
          to="/connections"
          className={cn(
            "hidden lg:flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors relative",
            isActive("/connections")
              ? "bg-primary/10 text-primary"
              : "text-muted-foreground hover:text-foreground hover:bg-accent"
          )}
        >
          <Users className="h-4 w-4" />
          <span className="hidden xl:inline">Connections</span>
          {pendingCount > 0 && (
            <Badge variant="destructive" className="h-5 px-1.5 text-xs">
              {pendingCount}
            </Badge>
          )}
        </Link>
      )}

      <ActivityCenter />

      <div className="hidden lg:block">
        <UserMenu />
      </div>
    </div>
  );
}
